import {
	DocumentItemViewModel,
	ListLocationViewModel,
	ListLocationModel,
	RecentDocumentItemViewModel
} from "client/Api/Documents/SharePoint/common";
import { RootFolder } from "./models";

function convertToLocationModel(location: ListLocationViewModel): ListLocationModel {
	const { siteUrl, listId } = location;
	return { siteUrl, listId };
}

function isRootFolder(documentItem: DocumentItemViewModel | RootFolder | RecentDocumentItemViewModel): documentItem is RootFolder {
	return ("isRoot" in documentItem && documentItem.isRoot === true);
}

export {
	convertToLocationModel,
	isRootFolder
};
